import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TicketUpdate from '../../components/TicketUpdate'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import { useParams } from 'react-router-dom'
import Copyright from '../../components/common/Copyright'
import { useProject } from '../../context/ProjectContext'

export default function TicketUpdateCreatePage({ setBlockScreen }: any) {
  const { ticket_number } = useParams()
  const { isProjectUndefined } = useProject();

  return (<>
    <TopSideBar currentSection='tickets' disableProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Tickets
          </Link>
          <Typography fontFamily='Poppins' color="darkgreen">
            Actualización
          </Typography>
          <Typography color="darkgreen" fontWeight={"bold"}>
            Nueva
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction
        title={`Nueva Actualización - #${ticket_number}`}
      >
      </TitlebarAction>

      {!isProjectUndefined() && (
        <TicketUpdate
          setBlockScreen={setBlockScreen}
          action='create'
          ticket_number={ticket_number}
        />
      )}

      <Copyright />
    </PageContainer>
  </>)
}